import React from 'react';
import { Accordion, AccordionTab } from 'primereact/accordion';

export const CustomAccordion = (props) => {

    const { activeIndex, onTabChange, header, content, headerClass, headerStyle, contentStyle, contentClass } = props;

    return (
        <Accordion activeIndex={activeIndex} onTabChange={onTabChange}>
            <AccordionTab
                headerStyle={headerStyle}
                header={header}
                headerClassName={headerClass}
                contentStyle={contentStyle}
                contentClassName={contentClass}>
                {content}
            </AccordionTab>
        </Accordion>
    );
}